import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { AbstractBean } from '@app/core/model/abstract-bean';
import { AssetType } from '@app/core/model/entities/asset/asset-type';
import { FieldConfig, FieldConfigInput, FormNode } from '@app/core/model/other/field-config';
import { Expose, Transform, Type } from 'class-transformer';

/**
 * GridConfigInput for updating GridConfigs.
 */
export interface UpdateGridConfigInput {
  customOptions?: Record<string, any>;
  columnGroups?: ColumnGroupInput[];
}
export interface ColumnGroupInput {
  code: string;
  label: string;
  order: number;
  assetTypeIds?: string[];
  allAssetTypes?: boolean;
  entityType?: EntityTypeEnum;
  customOptions?: Record<string, any>;
  columns?: FieldConfigInput[];
}
export class GridConfig extends AbstractBean implements FormNode {
  public code: string;

  public customOptions?: Record<string, any>;

  @Expose({name: 'columnGroupsList'})
  @Type(() => ColumnGroup)
  public children: ColumnGroup[];

  @Expose({name: '__typename'})
  public graphQlTypeName: string;

  public get label(): string {
    return `${'MENU.' + this.code.toUpperCase()}`;
  }
}

export class ColumnGroup implements FormNode {
  public code: string;
  public order: number;
  public customOptions?: {
    [option: string]: any
  };
  public label: string;

  @Transform(({value}) => EntityTypeEnum[value])
  public entityType: EntityTypeEnum;

  public allAssetTypes?: boolean;
  @Expose({name: 'assetTypesList'})
  public assetTypes: AssetType[];

  @Expose({name: 'columnsList'})
  @Type(() => FieldConfig)
  public children: FieldConfig[];

  @Expose({name: '__typename'})
  public graphQlTypeName: string;
}
